// Module
var code = "<div class=\"rip-dialog-popup\"> <div class=\"rip-dialog-popup-body\" ng-transclude></div> </div> ";
// Exports
module.exports = code;